import { type FC } from 'react';
import { type HTMLMotionProps } from 'framer-motion';

import { type ContractRewardType } from '@/common/types/contract';
import { ContractRewardMotion } from '@/components/Animations/ContractRewardMotion/ContractRewardMotion';
import { MotionPicture } from '@/components/ui/Picture/Picture';

import { images } from './config';

interface ContractRewardItemProps {
  motionProps: Partial<Omit<HTMLMotionProps<'div'>, 'children'>>;
  title: string | number;
  extraText?: string;
  description: string;
  kind: ContractRewardType;
  classNames?: {
    title?: string;
    description?: string;
    wrapper?: string;
  };
  withVipStatus?: boolean;
}

const ContractRewardItem: FC<ContractRewardItemProps> = ({
  motionProps,
  title,
  extraText,
  description,
  kind,
  classNames,
  withVipStatus,
}) => {
  const image = images[kind];

  return (
    <ContractRewardMotion
      motionProps={motionProps}
      title={title}
      extraText={extraText}
      description={description}
      classNames={classNames}
    >
      <div className="w-12 h-12 shrink-0 relative">
        <MotionPicture className="w-12 h-12 shrink-0" {...image} alt={kind} />
        {!!withVipStatus && (
          <div className="absolute top-0 right-[-30%]">
            <img src="/img/VIP/vip-icon.png" alt="" width={24} />
          </div>
        )}
      </div>
    </ContractRewardMotion>
  );
};

export { ContractRewardItem };
